<template>
  <Page class="page-rnr-person-agreement">
    <template #slot-title>
      <span>{{ currentFlow }}/{{ totalFlow }}</span>
      <!-- <span>责任告知书</span> -->
      <span>{{ convertLanage('实名认证隐私政策与责任告知书') }}</span>
    </template>
    <div class="page-rnr-main-card">
      <van-loading v-if="!notificationUrl" class="global-loading" color="#0094ff" />
      <Painter ref="painterRef" v-else>
        <img crossOrigin :src="notificationUrl">
        <img :src="signUrl" class="fixed-right">
      </Painter>
    </div>
    <div class="page-rnr-sign-wrapper">
      <div v-if="signUrl" class="page-rnr-sign-fill" @click="openSign">
        <img :src="signUrl" class="page-rnr-sign-img">
        <div class="page-rnr-sign-btn">{{ convertLanage('重签') }}</div>
      </div>
      <div v-else class="page-rnr-sign" @click="openSign">{{ convertLanage('点击在此处签名') }}</div>
    </div>
    <template #slot-operation>
      <van-button class="page-rnr-main-btn-before lastStep" round @click="handleToBefore">{{ convertLanage('上一步') }}</van-button>
      <van-button :disabled="btnDisable" :loading="loading" type="primary" class="page-rnr-main-btn-next" round color="linear-gradient(120deg, #000 0%, #000 97%)" @click="handleToNext">{{ convertLanage('下一步') }}</van-button>
    </template>
    <Sign :visible.sync="showSign" @submit="handleSignChange" />
  </Page>
</template>

<script>
import Painter from '@/components/Painter'
import { fileUpload } from '@/api/rnr'
import { SET_PERSON_DUTY_PIC, DISPATCH_INIT_PROTOCAL } from '@/store/modules/rnr'
import Page from '@/components/Page'
import signMixin from '@/minxin/sign'
import flowMixin from '@/minxin/flow'
import { convertLanage } from '@/utils/lanage'

export default {
  name: 'RnrPersonNotification',
  components: { Page, Painter },
  mixins: [flowMixin, signMixin],
  data() {
    return {
      loading: false,
      showSms: false,
      notificationUrl: ''
    }
  },
  activated() {
    const query = this.$route.query
    if (query.idCardType) {
      this.idCardType = query.idCardType
    }
  },
  async mounted() {
    // 查询协议数据
    await this.$store.dispatch(`rnr/${DISPATCH_INIT_PROTOCAL}`)
    // 当前请求到的协议数据
    const { protocal } = this.$store.getters
    // 协议链接
    if (protocal[window.os.isTablet ? 'realnameNoticeVertical' : 'realnameNoticeHorizontal'] == null) {
      this.notificationUrl = '1'
    } else {
      this.notificationUrl = protocal[window.os.isTablet ? 'realnameNoticeVertical' : 'realnameNoticeHorizontal'].fileUrl
    }
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 调到到下一页：腾讯的实名认证平台
     */
    async handleToNext() {
      // 展示loading框
      this.loading = true
      try {
        // 开始绘制canvas
        const file = await this.$refs.painterRef.draw()
        // 开始导出图片
        const { uuid } = await fileUpload({ file })
        // 开始保存数据
        this.$store.commit(`rnr/${SET_PERSON_DUTY_PIC}`, {
          dutyPic: [uuid]
        })
        // 跳转到
        // this.routerToNextPage('RnrPersonAgreement', { idCardType: this.formData.certType })
        this.routerToNextPage('RnrPersonAgreement')
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },

    /**
     * 跳转到上一页
     */
    handleToBefore() {
      // 回退到上个页面
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
@import "../rnr.scss";
.img-sign {
  width: auto;
  height: 120px;
  margin: -120px 0 0 52%;
  transition: transform 0.5s ease;
  position: relative;
  top: 300px;
  left: 200px;
}
.page-rnr-person-agreement {
  .page-rnr-main {
    margin-top: 30px;
    .page-rnr-main-card {
      padding: 24px 24px 168px;
      height: calc(100vh - 450px);
      overflow: auto;
      .page-rnr-main-canvas {
        width: 100%;
      }
      .paint-sign-image {
        width: auto;
        height: 120px;
        margin: -120px 0 0 52%;
      }
    }
    .page-rnr-sign-wrapper {
      background: #ffffff;
      bottom: 196px;
      padding: 24px 32px;
      position: fixed;
      left: 24px;
      right: 24px;

      .page-rnr-sign {
        align-items: center;
        background: #F7F8FA;
        border: 1px dashed rgba(7, 97, 243, 1);
        border-radius: 12px;
        color: #0761F3;
        display: flex;
        font-size: 24px;
        font-weight: 400;
        height: 120px;
        justify-content: center;
      }
      .page-rnr-sign-fill {
        align-items: center;
        background: #F7F8FA;
        border-radius: 12px;
        bottom: 148px;
        display: flex;
        height: 120px;
        justify-content: space-between;
        padding: 0px 48px 0px 132px;
        .page-rnr-sign-img {
          width: auto;
          height: 100px;
        }
        .page-rnr-sign-btn {
          color: #0761F3;
          font-size: 24px;
          font-weight: 400;
        }
      }
    }
    .page-rnr-main-fixed-btn-group {
      display: flex;
      justify-content: space-between;
      bottom: -68px !important;
      .page-rnr-main-btn-before {
        color: #242424 !important;
        flex: 1;
        height: 96px;
      }
      .page-rnr-main-btn-next {
        flex: 2;
        margin-left: 40px;
        height: 96px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rnr/person/notification.vue